import React, { cloneElement, useEffect, useRef, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import loginleft from "../../assets/images/loginleftnew1.png";
import logo from "../../assets/images/loginlogo.svg";
import { commonservices } from "../../services/CommonServices";
import { VerifyOtp } from "../../services/ReduxTookit/Slice/AuthFlowRedux";
//import { ResendEmailOtp } from "../../services/ReduxTookit/Slice/LoginRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { SEND_SIGNUP_OTP, VERIFY_SIGNUP_OTP } from "../../services/ReduxTookit/Slice/AuthFlowRedux";

function SignOtpPage() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const [Loading, setLoading] = useState(false);
    const [ResendLoading, setResendLoading] = useState(false);
    const [otpTimer, setOtpTimer] = useState(60);
    const [encryptedData, setEncryptedData] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
        const encryptedValue = searchParams.get("t");
        if (encryptedValue) {
            setEncryptedData(encryptedValue);
        }
    }, []);
    const [input, setInput] = useState({
        Number1: "",
        Number2: "",
        Number3: "",
        Number4: "",
        Number5: "",
        Number6: "",
        errors: {
            Number1: "",
            Number2: "",
            Number3: "",
            Number4: "",
            Number5: "",
            Number6: "",
            ValidationRules: [
                {
                    FieldName: "Number1",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "Number2",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "Number3",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "Number4",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "Number5",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "Number6",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
            ],
        },
    });
    const inputRefs = {
        Number1: useRef(),
        Number2: useRef(),
        Number3: useRef(),
        Number4: useRef(),
        Number5: useRef(),
        Number6: useRef(),
    };
    useEffect(() => {
        if (otpTimer > 0) {
            const timer = setInterval(() => {
                setOtpTimer(otpTimer - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [otpTimer]);

    const [SubscriberBasicDetails, setSubscriberBasicDetails] = useState({
        subscriberid: 0,
        firstname: "",
        lastname: "",
        email: "",
        contactno1: "",
        isdeveloper: false,
        isclient: true,
        emailotpid: "",
        otp: ""
    });

    const isValidJSON = (str) => {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    };

    useEffect(() => {
        if (encryptedData) {
            if (commonservices.getItem(encryptedData) && isValidJSON(commonservices.getDecryptData(encryptedData))) {
                setSubscriberBasicDetails(JSON.parse(commonservices.getDecryptData(encryptedData)));
            }
            else {
                navigate("/sign-up");
            }
        }
    }, [encryptedData]);


    const handleInputChange = (e, inputName) => {
        fnInputChange(e.target.value, inputName);
        const value = e.target.value;
        if (value !== "" && inputName !== "Number6") {
            inputRefs[inputName]?.current?.blur();
            const nextInputName = `Number${parseInt(inputName.replace("Number", "")) + 1
                }`;
            inputRefs[nextInputName]?.current?.focus();
        }
    };
    const handleKeyDown = (e, inputName) => {
        if (e.key === "Backspace") {
            if (e.target.value === "") {
                e.preventDefault();
                const currentIndex = parseInt(inputName.replace("Number", ""));
                if (currentIndex > 1) {
                    const prevInputName = `Number${currentIndex - 1}`;
                    inputRefs[prevInputName].current.focus();
                }
            }
        }
    };
    const handleSubmit = async (e) => {

        e?.preventDefault();
        let obj = commonservices.fnCheckValidationOfObject(input);
        setInput({
            ...obj.obj,
        });
        if (obj.isValid) {
            setLoading(true);

            let body = structuredClone(SubscriberBasicDetails);
            body.emailotpid = encryptedData;
            body.otp = input.Number1 + input.Number2 + input.Number3 + input.Number4 + input.Number5 + input.Number6;

            dispatch(VERIFY_SIGNUP_OTP(body)).then((response) => {
                if (response?.payload?.isValidate) {
                    navigate(`/change-password/${response?.payload?.data?.data.verificationlink}`);
                    setLoading(false);
                }
                if (!response?.payload?.isValidate) {
                    setLoading(false);
                }
            });
        }
    };
    const fnResendOTP = async () => {
        setInput({
            ...input,
            Number1: "",
            Number2: "",
            Number3: "",
            Number4: "",
            Number5: "",
            Number6: "",
        });
        setResendLoading(true);

        dispatch(SEND_SIGNUP_OTP({ email: SubscriberBasicDetails.email, name: SubscriberBasicDetails.firstname + " " + SubscriberBasicDetails.lastname })).then((response) => {
            if (response?.payload?.isValidate) {
                setResendLoading(false);
                setOtpTimer(60);
                commonservices.setItem(response?.payload?.data?.data?.emailotpid, JSON.stringify(SubscriberBasicDetails));
                navigate("/sign-up-otp/?t=" + response?.payload?.data?.data?.emailotpid);

            }
            if (!response?.payload?.isValidate) {
                setResendLoading(false);
                setOtpTimer(60);
            }
        });
    };

    const fnInputChange = (value, tag) => {
        if (value) {
            setInput({
                ...input,
                [tag]: value,
                errors: {
                    ...input.errors,
                    [tag]: "",
                },
            });
        } else {
            setInput({
                ...input,
                [tag]: "",
            });
        }
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                event?.preventDefault();
                handleSubmit(event);
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    });

    const handlePaste = (event) => {
        const text = event.clipboardData.getData("text");
        let num1 = "",
            num2 = "",
            num3 = "",
            num4 = "",
            num5 = "",
            num6 = "";

        for (let i = 0; i < text?.length; i++) {
            if (i === 0) {
                num1 = text?.[i];
            } else if (i === 1) {
                num2 = text?.[i];
            } else if (i === 2) {
                num3 = text?.[i];
            } else if (i === 3) {
                num4 = text?.[i];
            } else if (i === 4) {
                num5 = text?.[i];
            } else if (i === 5) {
                num6 = text?.[i];
            }
        }

        setInput({
            ...input,
            Number1: num1,
            Number2: num2,
            Number3: num3,
            Number4: num4,
            Number5: num5,
            Number6: num6,
        });
    };

    return (
        <div className="login-page-main-wrapper forgot-password-page-main">
            {(Loading || ResendLoading) && <MainpageLoader />}
            <div className="w-100 text-start loginlogo-wrapper">
                <img src={logo} alt="logo" className="loginlogo" />
            </div>
            <div className="login-page-main">
                <div className="login-right ms-auto">
                    <div className="loginleftnew">
                        <div className="loginleftnew-svg">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="110"
                                height="110"
                                viewBox="0 0 110 110"
                                fill="none"
                            >
                                <path
                                    className="rotate-clockwise"
                                    d="M25.5282 89.5002C21.5581 87.2081 19.7936 80.9488 14.9413 80.9488C11.9417 81.3014 6.3836 83.0646 5.14846 78.9211C4.53089 75.3947 -2.0859 65.6972 2.76642 62.9643C4.97202 61.4656 9.47143 59.7024 9.11854 56.3524C8.32452 52.7378 10.9713 47.9772 7.70696 45.2443C5.41314 43.393 0.207916 40.7482 2.23707 36.9573C4.35444 34.0481 6.47183 22.4111 11.8535 23.9979C14.5002 24.3506 18.9114 26.2901 21.0288 23.7334C23.0579 20.6479 28.2631 19.1492 27.9102 14.9175C27.6456 12.0083 25.7929 6.36609 29.9394 5.13186C33.4684 4.60291 43.2612 -2.09721 45.9079 2.75155C47.496 4.95553 49.2604 9.45166 52.5247 9.09903C56.1419 8.39375 60.9942 10.9504 63.6409 7.77664C65.5819 5.4845 68.2286 0.194934 72.0222 2.31076L82.6091 7.15951C86.5792 8.74638 84.4618 14.0359 83.9325 17.0334C83.2267 21.1768 88.3437 23.1163 90.1081 26.2901C93.4606 30.698 101.577 23.8216 103.783 29.9928L107.841 40.8363C109.517 44.8035 104.312 47.0956 101.754 48.7707C98.4012 51.2391 100.607 56.176 99.6363 59.7906C98.9305 62.9643 103.43 65.1683 105.371 66.8433C110.047 69.8407 102.636 79.1856 101.842 82.5356C100.254 86.591 94.9605 84.387 91.9608 83.858C87.8143 83.2409 85.7852 88.266 82.6091 90.1173C79.8742 91.8805 81.5504 96.6411 81.7269 99.1977C82.8738 104.664 71.0518 105.986 68.0521 107.837C64.0821 109.512 61.8765 104.223 60.112 101.754C57.6417 98.3162 52.7894 100.52 49.1722 99.5504C45.9079 98.8451 43.7906 103.429 42.1143 105.369C39.0265 110.041 29.7629 102.636 26.3222 101.754C21.7346 99.9912 25.2635 92.6739 25.5282 89.5002Z"
                                    fill="#FEFEFE"
                                    stroke="#231F20"
                                    stroke-width="2"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                />
                                <path
                                    className="rotate-counterclockwise"
                                    d="M81.0219 44.1862C93.9909 79.2736 42.027 99.3739 27.9111 64.7274C14.9422 29.64 66.9061 9.53968 81.0219 44.1862Z"
                                    stroke="#231F20"
                                    stroke-width="2"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                />
                            </svg>
                        </div>
                        <div className="dots-svg">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="53"
                                height="11"
                                viewBox="0 0 53 11"
                                fill="none"
                            >
                                <path
                                    className="path path3"
                                    d="M28.7472 10.2202C25.8359 10.132 19.572 11.3663 19.6602 6.60569C19.3955 3.96091 19.6602 -0.00627534 23.2773 0.0818839C26.1887 0.170043 32.4526 -1.06415 32.3644 3.69644C32.6291 6.34122 32.3644 10.3084 28.7472 10.2202Z"
                                />
                                <path
                                    className="path path2"
                                    d="M9.25049 10.2202C6.3391 10.132 -0.0129968 11.3663 0.0752272 6.60569C-0.189445 3.96091 0.0752058 -0.00627534 3.69239 0.0818839C6.692 0.170043 12.9559 -1.06415 12.8677 3.69644C13.1324 6.34122 12.8677 10.3084 9.25049 10.2202Z"
                                />
                                <path
                                    className="path path1"
                                    d="M48.3335 10.2202C45.3339 10.132 39.07 11.3663 39.1582 6.60569C38.8936 3.96091 39.1582 -0.00627534 42.7754 0.0818839C45.6868 0.170043 52.0389 -1.06415 51.9507 3.69644C52.2154 6.34122 51.9507 10.3084 48.3335 10.2202Z"
                                />
                            </svg>
                        </div>
                        <div className="dots-svg2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="53"
                                height="11"
                                viewBox="0 0 53 11"
                                fill="none"
                            >
                                <path
                                    className="path path3"
                                    d="M28.7472 10.2202C25.8359 10.132 19.572 11.3663 19.6602 6.60569C19.3955 3.96091 19.6602 -0.00627534 23.2773 0.0818839C26.1887 0.170043 32.4526 -1.06415 32.3644 3.69644C32.6291 6.34122 32.3644 10.3084 28.7472 10.2202Z"
                                />
                                <path
                                    className="path path2"
                                    d="M9.25049 10.2202C6.3391 10.132 -0.0129968 11.3663 0.0752272 6.60569C-0.189445 3.96091 0.0752058 -0.00627534 3.69239 0.0818839C6.692 0.170043 12.9559 -1.06415 12.8677 3.69644C13.1324 6.34122 12.8677 10.3084 9.25049 10.2202Z"
                                />
                                <path
                                    className="path path1"
                                    d="M48.3335 10.2202C45.3339 10.132 39.07 11.3663 39.1582 6.60569C38.8936 3.96091 39.1582 -0.00627534 42.7754 0.0818839C45.6868 0.170043 52.0389 -1.06415 51.9507 3.69644C52.2154 6.34122 51.9507 10.3084 48.3335 10.2202Z"
                                />
                            </svg>
                        </div>
                        <div className="dots-svg3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="53"
                                height="11"
                                viewBox="0 0 53 11"
                                fill="none"
                            >
                                <path
                                    className="path path3"
                                    d="M28.7472 10.2202C25.8359 10.132 19.572 11.3663 19.6602 6.60569C19.3955 3.96091 19.6602 -0.00627534 23.2773 0.0818839C26.1887 0.170043 32.4526 -1.06415 32.3644 3.69644C32.6291 6.34122 32.3644 10.3084 28.7472 10.2202Z"
                                />
                                <path
                                    className="path path2"
                                    d="M9.25049 10.2202C6.3391 10.132 -0.0129968 11.3663 0.0752272 6.60569C-0.189445 3.96091 0.0752058 -0.00627534 3.69239 0.0818839C6.692 0.170043 12.9559 -1.06415 12.8677 3.69644C13.1324 6.34122 12.8677 10.3084 9.25049 10.2202Z"
                                />
                                <path
                                    className="path path1"
                                    d="M48.3335 10.2202C45.3339 10.132 39.07 11.3663 39.1582 6.60569C38.8936 3.96091 39.1582 -0.00627534 42.7754 0.0818839C45.6868 0.170043 52.0389 -1.06415 51.9507 3.69644C52.2154 6.34122 51.9507 10.3084 48.3335 10.2202Z"
                                />
                            </svg>
                        </div>
                        <img src={loginleft} alt="loginleft" />
                    </div>
                    {
                        SubscriberBasicDetails.email &&
                        <div className="main-login-form">
                            <h3>Enter OTP</h3>
                            <p>
                                Enter OTP to securely verify your identity and access advanced
                                data analytics and quantum computing solutions.
                            </p>
                            <div className="login-form-inner">
                                <Form
                                    onSubmit={(e) => {
                                        handleSubmit(e);
                                    }}
                                >
                                    <Form.Group className="form-group mb-3">
                                        <Form.Label className="login-label">
                                            OTP<span className="ms-1 red-color-text">*</span>
                                        </Form.Label>
                                        <Row>
                                            <Col md={2}>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        className="login-input text-center"
                                                        maxLength={1}
                                                        ref={inputRefs.Number1}
                                                        value={input.Number1}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => handleInputChange(e, "Number1")}
                                                        onKeyUp={(e) => handleKeyDown(e, "Number1")}
                                                        isInvalid={input?.errors?.Number1}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                        onPaste={handlePaste}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        className="login-input text-center"
                                                        maxLength={1}
                                                        value={input?.Number2}
                                                        ref={inputRefs.Number2}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => handleInputChange(e, "Number2")}
                                                        onKeyUp={(e) => handleKeyDown(e, "Number2")}
                                                        isInvalid={input?.errors?.Number2}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        className="login-input text-center"
                                                        maxLength={1}
                                                        value={input?.Number3}
                                                        ref={inputRefs.Number3}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => handleInputChange(e, "Number3")}
                                                        onKeyUp={(e) => handleKeyDown(e, "Number3")}
                                                        isInvalid={input?.errors?.Number3}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        className="login-input text-center"
                                                        maxLength={1}
                                                        value={input?.Number4}
                                                        ref={inputRefs.Number4}
                                                        onChange={(e) => handleInputChange(e, "Number4")}
                                                        onKeyUp={(e) => handleKeyDown(e, "Number4")}
                                                        onFocus={(e) => e.target.select()}
                                                        isInvalid={input?.errors?.Number4}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        className="login-input text-center"
                                                        maxLength={1}
                                                        value={input?.Number5}
                                                        ref={inputRefs.Number5}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => handleInputChange(e, "Number5")}
                                                        onKeyUp={(e) => handleKeyDown(e, "Number5")}
                                                        isInvalid={input?.errors?.Number5}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        className="login-input text-center"
                                                        maxLength={1}
                                                        value={input?.Number6}
                                                        ref={inputRefs.Number6}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => handleInputChange(e, "Number6")}
                                                        onKeyUp={(e) => handleKeyDown(e, "Number6")}
                                                        isInvalid={input?.errors?.Number6}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                    <div className="d-flex  mb-3   justify-content-between">
                                        <div className="register-link-wrapper">
                                            Don't receive the code?{" "}
                                            <button
                                                type="reset"
                                                disabled={otpTimer ? "disable" : ""}
                                                className={otpTimer ? "disable" : ""}
                                                onClick={() => {
                                                    fnResendOTP();
                                                }}
                                            >
                                                Resend

                                            </button>
                                        </div>
                                        <span className="theme-color-text">
                                            {otpTimer === 60
                                                ? "00:00"
                                                : `00:${otpTimer < 10 ? `0${otpTimer}` : otpTimer}`}
                                        </span>
                                    </div>
                                    <button
                                        disabled={Loading}
                                        className="blue-sign-in-btn w-100"
                                        type="submit"
                                    >
                                        {Loading ? (

                                            <SubmitLoading />
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                </Form>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </div>
    );
}

export default SignOtpPage;
